import {Directive, HostBinding, HostListener, Injector, Optional} from '@angular/core';

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";

const DEFAULT_CLS = 'btn-group app-button-group';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-buttongroup',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmButtonGroup]',
  providers: [
  provideAsWidgetRef(ButtonGroupDirective)
  ],
  standalone: true,
  exportAs: 'wmButtonGroup'
})
export class ButtonGroupDirective extends StylableComponent {
  static initializeProps = register('wm-buttongroup');
  @HostBinding('class.btn-group-vertical') vertical: boolean;
  @HostListener('click', ['$event']) handleClick(event: any){
    const $target = $(event.target).closest('.app-button');
    $(this.nativeElement).find('.app-button').removeClass('selected');
    $target.addClass('selected');
  }
  constructor(inj: Injector, @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }
}

